var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.url)?_c('img',{staticClass:"max-w-full h-auto block",attrs:{"src":_setup.url,"alt":_vm.alt}}):_c('div',{staticClass:"w-full h-full bg-gray-100"})
}
var staticRenderFns = []

export { render, staticRenderFns }